<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-bus-stop`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M42 4a2 2 0 011.995 1.85L44 6v27a2 2 0 01-1.85 1.995L42 35h-6v9a1 1 0 01-1 1h-2a1 1 0 01-1-1v-9H16v9a1 1 0 01-1 1h-2a1 1 0 01-1-1v-9H6a2 2 0 01-1.995-1.85L4 33V6a2 2 0 011.85-1.995L6 4h36zm-2 19H8v8h32v-8zm0-15H8v11h32V8zm-24 3a1 1 0 011 1v2a1 1 0 01-1 1h-4a1 1 0 01-1-1v-2a1 1 0 011-1h4z"/></svg>
</template>
<script>

export default {
  name: 'IconBusStop',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
